import { type ExerciseWithVideo } from "@fitness-app/data-models/entities/Exercise";
import {
  TrainingStatus,
  WORKOUT_EXERCISES_TYPE,
  type ExerciseInWorkout,
  type ProgramWorkout,
  type WorkoutExercisesType,
} from "@fitness-app/data-models/entities/TrainingProgram";

import recreateExerciseDataForAlternativeExercise from "./recreateExerciseDataForAlternativeExercise";

// TRE-727 — THE exercise-swap semantics, extracted from the redux thunk
// updateExerciseToAlternative so the client flow and the advisor's replace-exercise
// tool cannot drift: recreate sets for the replacement (series/superset membership
// preserved, statuses reset), swap in the exercise row, stamp updatedAt and force
// status NEW on the slot and on the workout.

const WORKOUT_PARTS: WorkoutExercisesType[] = [
  WORKOUT_EXERCISES_TYPE.PRE_WORKOUT,
  WORKOUT_EXERCISES_TYPE.NORMAL,
  WORKOUT_EXERCISES_TYPE.POST_WORKOUT,
];

export interface ReplaceExerciseResult {
  workout: ProgramWorkout;
  workoutPart: WorkoutExercisesType;
  previous: ExerciseInWorkout;
  updated: ExerciseInWorkout;
}

export const replaceExerciseInWorkout = (
  workout: ProgramWorkout,
  exerciseInWorkoutId: string,
  replacement: ExerciseWithVideo,
  now = new Date().toISOString(),
): ReplaceExerciseResult | null => {
  for (const workoutPart of WORKOUT_PARTS) {
    const list = workout[workoutPart] ?? [];
    const previous = list.find((exercise) => exercise.id === exerciseInWorkoutId);
    if (!previous) {
      continue;
    }

    const updated: ExerciseInWorkout = {
      ...recreateExerciseDataForAlternativeExercise(previous, replacement, true),
      exercise: replacement,
      exerciseId: replacement.id,
      updatedAt: now,
      status: TrainingStatus.NEW,
    };

    return {
      workoutPart,
      previous,
      updated,
      workout: {
        ...workout,
        [workoutPart]: list.map((exercise) =>
          exercise.id === exerciseInWorkoutId ? { ...exercise, ...updated } : exercise,
        ),
        updatedAt: now,
      },
    };
  }

  return null;
};
